import React from "react";
import { i18n } from "@/locales";
import { ReactNode } from "react";
import { get } from "lodash";
import { KeywordSTT } from "@/components/KeywordSTT";

const KEYWORD_CONFIG = [
  {
    key: "请在手机打开 Google Authenticator / Microsoft Authenticator 扫码添加 MFA",
    mark: "pleaseDownloadAuthenticator",
  },
  {
    key: "Open Google Authenticator / Microsoft Authenticator on your phone and scan below QR code",
    mark: "pleaseDownloadAuthenticator",
  },
  {
    key: "Please open Google Authenticator / Microsoft Authenticator and enter account number and secret key",
    mark: "pleaseDownloadAuthenticatorMedia",
  },
  {
    key: "请打开 Google Authenticator / Microsoft Authenticator 输入账号和密钥",
    mark: "pleaseDownloadAuthenticatorMedia",
  },
  {
    key: "MFA",
  },
  {
    key: "OTP",
  },
];

export const authingTranslation: (ns: string, options?: ReactNode[]) => ReactNode = (ns, options) => {
  const resources = i18n.getDataByLanguage(i18n.language)?.translation;

  const namespaces = ns.split(".");

  const value = get(resources, namespaces);

  if (!value) return ns;

  if (typeof value !== "string") return ns;

  const keyList = KEYWORD_CONFIG.filter((i) => value.search(i.key) !== -1);

  if (keyList.length === 0) return value;

  // TODO 先拿一个吧
  const valueArr: string[] = value.split(keyList[0].key);

  return valueArr.map((item: string, index: number) =>
    index !== valueArr.length - 1 ? (
      <>
        {item}
        <KeywordSTT content={keyList[0].key} mark={keyList[0].mark} />
      </>
    ) : (
      item
    )
  );
};

export const useAuthingTranslation = () => {
  const resources = i18n.getDataByLanguage(i18n.language)?.translation;

  const at: (ns: string, options?: ReactNode[]) => ReactNode = (ns, options) => {
    const namespaces = ns.split(".");

    const value = get(resources, namespaces);

    if (!value) return ns;

    if (typeof value !== "string") return ns;

    const keyList = KEYWORD_CONFIG.filter((i) => value.search(i.key) !== -1);

    if (keyList.length === 0) return value;

    // TODO 先拿一个吧
    const valueArr: string[] = value.split(keyList[0].key);

    return valueArr.map((item: string, index: number) =>
      index !== valueArr.length - 1 ? (
        <>
          {item}
          <KeywordSTT content={keyList[0].key} mark={keyList[0].mark} />
        </>
      ) : (
        item
      )
    );
  };

  return {
    at,
  };
};
